.allSportsMenu {
  position: fixed;
  background: var(--cxy-color-midnight-blue-400);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  bottom: 0;
  height: calc(70vh - 66px);
  height: -webkit-calc(70vh - 66px);
  height: -moz-calc(70vh - 66px);
  max-height: calc(70vh - 66px);
  overscroll-behavior: contain;
  transform: translateY(100%) scaleY(0);
  transition: 0.3s ease-in;
  width: 100%;
  z-index: var(--cxy-z-index-hidden);
}

@media (min-width: 1025px) {
  .allSportsMenu {
    display: none;
  }
}

.allSportsMenu .content {
  display: grid;
  grid-template-rows: 50px 100px 1fr;
  height: 100%;
}

.allSportsMenu .content .header {
  display: flex;
  align-items: center;
  color: var(--cxy-color-white);
  font-size: 32px;
  justify-content: space-between;
  margin: 0;
  padding: 16px 8px;
}

.allSportsMenu .content .header button {
  font-size: 30px;
}

.allSportsMenu .content button {
  color: inherit;
  cursor: pointer;
}

.allSportsMenu .content h2 {
  font-family: var(--cxy-font-family-sans);
  font-weight: 700;
  font-size: 1.2rem;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0.5px;
  margin-top: 0;
  margin-bottom: 0;
  color: var(--cxy-color-white);
  padding: 0;
}

.allSportsMenu.open {
  bottom: 66px;
  transform: translateY(0) scaleY(1);
}

.allSportsMenu.fullHeight {
  max-height: calc(100vh - 66px);
  height: calc(100vh - 66px);
  border-radius: 0;
}
